import { InputBaseComponentProps, TextField } from "@mui/material"
import { InputHTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"
import { useController, useForm } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    value?: any
    inputProps?: any
    borderRadius?: string,
    onChange:any
} 

type DatePickerComponentProps = typeof DatePicker & { 
    borderRadius?: string 
}

export function DatePickerComponent({ borderRadius = '12px', ...rest }: DatePickerComponentProps) {
    return (
        <DatePicker
            sx={{
                '& .MuiOutlinedInput-root': {
                    height: 40
                    // borderRadius: borderRadius, // Altere o valor conforme necessário
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    // height: 40
                    // borderRadius: borderRadius, // Altere o valor conforme necessário
                },
            }}
            {...rest}
        />
    )
}